'use strict';

var Emitify = require('emitify/legacy');

module.exports = function (entry) {
    var emitter = Emitify();

    setTimeout(function () {
        FindIt(emitter, entry);
    }, 0);

    return emitter;
};

function FindIt(emitter, entry) {
    if (!(this instanceof FindIt)) return new FindIt(emitter, entry);

    this._dirs = 0;
    this._first = true;

    this._find(emitter, entry);
}

FindIt.prototype._find = function (emitter, entry) {
    var _this = this;

    if (entry.isFile) {
        emitter.emit('file', entry.fullPath, entry);

        if (this._first) emitter.emit('end');

        return;
    }

    if (this._first) this._first = false;

    emitter.emit('directory', entry.fullPath, entry);

    ++this._dirs;

    entry.createReader().readEntries(function (entries) {
        [].forEach.call(entries, function (entry) {
            _this._find(emitter, entry);
        });

        --_this._dirs;

        if (!_this._dirs) emitter.emit('end');
    });
};